import { Reveal } from "./Reveal";
import { WHY_GOOD_SHOT } from "../lib/data";

export const WhyGoodShot = () => (
  <section id="why" data-testid="why-section" className="relative py-20 md:py-32 border-t border-white/5 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="max-w-3xl mb-12 md:mb-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5 md:mb-6">Why Good Shot?</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black uppercase tracking-tight text-white text-3xl sm:text-4xl md:text-6xl leading-[0.95]">
            A hospitality partner built for <span className="text-[#D4AF37]">flawless execution.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {WHY_GOOD_SHOT.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.title} delay={0.05 * (i % 3)}>
              <div
                data-testid={`why-item-${i}`}
                className="h-full bg-[#0a0a0a] border border-white/5 hover:border-[#D4AF37]/40 transition-colors duration-500 p-7 md:p-8"
              >
                <Icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.4} />
                <h3 className="mt-6 font-display font-bold uppercase tracking-wide text-white text-lg md:text-xl leading-tight">{p.title}</h3>
                <p className="mt-3 text-sm md:text-[15px] text-white/55 font-light leading-relaxed">{p.copy}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
